import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmComponent } from './confirm.component';
import {ReactiveFormsModule} from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule
    ],
  declarations: [ConfirmComponent],
  exports: [ConfirmComponent]
})
export class ConfirmModule { }
